import React from "react";

export const ChartSection = ({ header, children, height }) => {
  return (
    <div style={{ width: "100%", height: height, marginBottom: 0 }}>
      {header && <div style={{ fontSize: 20, fontWeight: 700 }}>{header}</div>}

      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          marginTop: 0,
          marginBottom: 0,
        }}
      >
        {children}
      </div>
    </div>
  );
};
